export default __webpack_public_path__ + "static/media/roam.149cb24b.png";